
export default class FundTransactionResponseModel {
    public transactionId: number = 0;
    public debit: number = 0;
    public credit: number = 0;
    public transactionDate?: Date;
    public transactionDescription: string = '';
}
